/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";

export default function PinningFeedback({
  positive = null,
  message = "",
  isOpen = false,
  status = "idle",
  isDesktop = false,
  onSelectPositive,
  onSelectNegative,
  onCancel,
  onSubmit,
  onUpdateMessage,
  ...restProps
}: any) {
  function isSending() {
    return status === "sending";
  }

  function shouldShowForm() {
    return isOpen && status !== "success";
  }

  return (
    <div
      {...restProps}
      className={cn(
        "px-2 pb-2",
        isDesktop && "absolute bottom-14 right-4 z-20 p-0",
        restProps?.className
      )}
      data-testid="pinning-feedback"
    >
      <div
        className={cn(
          "rounded-lg border border-gray-200 bg-white p-3 shadow-sm",
          isDesktop ? "w-[280px]" : "w-full"
        )}
      >
        {status === "success" ? (
          <div className="flex min-h-[36px] items-center text-xs text-green-700">
            {" "}
            Thanks for the feedback.{" "}
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between gap-3">
              <div className="text-xs font-medium text-gray-700">How is your session going?</div>
              <div className="flex items-center gap-1">
                <button
                  className={cn(
                    "cursor-pointer rounded-full border border-gray-200 bg-transparent p-1.5 transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
                    positive === true && "border-green-200 bg-green-50 hover:bg-green-100"
                  )}
                  type="button"
                  disabled={isSending()}
                  aria-pressed={positive === true}
                  data-testid="pinning-feedback-thumbs-up"
                  onClick={() => {
                    onSelectPositive?.();
                  }}
                >
                  <UseSvg
                    className={cn(
                      isDesktop ? "h-5 w-5" : "h-4 w-4",
                      positive === true ? "text-green-600" : "text-gray-500"
                    )}
                    icon="thumbs-up"
                    data-testid="use-svg"
                  />
                </button>
                <button
                  className={cn(
                    "cursor-pointer rounded-full border border-gray-200 bg-transparent p-1.5 transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
                    positive === false && "border-red-200 bg-red-50 hover:bg-red-100"
                  )}
                  type="button"
                  disabled={isSending()}
                  aria-pressed={positive === false}
                  data-testid="pinning-feedback-thumbs-down"
                  onClick={() => {
                    onSelectNegative?.();
                  }}
                >
                  <UseSvg
                    className={cn(
                      "rotate-180",
                      isDesktop ? "h-5 w-5" : "h-4 w-4",
                      positive === false ? "text-red-600" : "text-gray-500"
                    )}
                    icon="thumbs-up"
                    data-testid="rotate-180"
                  />
                </button>
              </div>
            </div>
            {shouldShowForm() ? (
              <div className="mt-3 flex flex-col gap-2">
                <textarea
                  className="mp-unmask font-inherit w-full resize-none rounded-md border border-gray-300 p-2 outline-none focus:border-blue-500 disabled:opacity-50"
                  value={message}
                  placeholder="Optional details"
                  rows={3}
                  style={{ fontSize: "16px" }}
                  disabled={isSending()}
                  data-testid="pinning-feedback-message"
                  onChange={e => {
                    onUpdateMessage?.(e.target.value);
                  }}
                />
                <div className="flex items-center justify-end gap-2">
                  <button
                    className="cursor-pointer rounded-md border border-gray-300 bg-transparent px-3 py-1 text-[13px] text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                    type="button"
                    disabled={isSending()}
                    onClick={() => {
                      onCancel?.();
                    }}
                    data-testid="cursor-pointer"
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button
                    className="cursor-pointer rounded-[4px] border-none bg-[#414192] px-3 py-1 text-[13px] font-bold !text-white hover:bg-[#06065a] disabled:cursor-not-allowed disabled:opacity-50"
                    type="button"
                    disabled={isSending() || positive === null}
                    onClick={() => {
                      onSubmit?.();
                    }}
                    data-testid="cursor-pointer-1"
                  >
                    {isSending() ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}

PinningFeedback.displayName = "PinningFeedback";
